import React, { useMemo } from "react";
import { Button } from "../ui/button";
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer } from "recharts";
import { Instagram, RefreshCw } from "lucide-react";
import { PRESENCE_FIELDS } from "../../lib/constants";

const ANGLE_TICK = { fill: "#94A3B8", fontSize: 11 };
const RADIUS_TICK = { fill: "#64748B", fontSize: 9 };
const RADIUS_DOMAIN = [0, 10];
const IG_FIELDS = [["followers", "Follower"], ["posts", "Post"], ["posts_per_week", "Post/sett."], ["avg_likes", "Like medi"], ["avg_comments", "Commenti medi"], ["following", "Seguiti"]];

export const PresenceTab = ({ p, fetching, onFetchInstagram }) => {
  const dp = p.digital_presence;
  const radarData = useMemo(() => PRESENCE_FIELDS.map((f) => ({ axis: f.label, value: (dp || {})[f.key] || 0 })), [dp]);
  const ig = p.ig_stats || {};
  const score = (key) => (dp || {})[key] || 0;

  return (
    <>
      {p.instagram && (
        <div className="mb-3 flex items-center justify-between gap-2 rounded-lg border border-border px-3 py-2" data-testid="ig-fetch-row">
          <div className="text-xs text-muted-foreground">
            {ig.source === "graph_api"
              ? <>Ultimo fetch Graph API: <span className="text-foreground">{(ig.fetched_at || "").slice(0, 16).replace("T", " ")}</span></>
              : "Leggi i dati reali del profilo dalla Instagram Graph API"}
          </div>
          <Button size="sm" variant="outline" onClick={onFetchInstagram} disabled={fetching} data-testid="ig-fetch-btn">
            <RefreshCw className={`mr-1.5 h-3.5 w-3.5 ${fetching ? "animate-spin" : ""}`} />
            {fetching ? "Lettura..." : "Aggiorna da Instagram"}
          </Button>
        </div>
      )}
      {Object.keys(ig).length > 0 && <IgStatsCard ig={ig} />}
      <div className="h-72 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={radarData} outerRadius="72%">
            <PolarGrid stroke="rgba(255,255,255,0.1)" />
            <PolarAngleAxis dataKey="axis" tick={ANGLE_TICK} />
            <PolarRadiusAxis domain={RADIUS_DOMAIN} tick={RADIUS_TICK} axisLine={false} />
            <Radar dataKey="value" stroke="#0EA5E9" fill="#0EA5E9" fillOpacity={0.35} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {PRESENCE_FIELDS.map((f) => (
          <div key={f.key} className="flex items-center justify-between rounded-lg border border-border px-3 py-2 text-sm">
            <span className="text-muted-foreground">{f.label}</span>
            <span className="font-heading tabular-nums">{score(f.key)}/10</span>
          </div>
        ))}
      </div>
    </>
  );
};

function IgStatsCard({ ig }) {
  return (
    <div className="mb-4 rounded-xl border border-primary/30 bg-primary/5 p-4" data-testid="ig-stats-real">
      <div className="mb-2 flex items-center justify-between label-caps text-primary">
        <span className="flex items-center gap-2"><Instagram className="h-3.5 w-3.5" /> Dati Instagram reali</span>
        {ig.source === "graph_api" && <span className="rounded-full bg-primary/20 px-2 py-0.5 text-[0.6rem]" data-testid="ig-source-graph">Graph API</span>}
        {ig.engagement_rate != null && <span className="text-[0.65rem] text-muted-foreground normal-case tracking-normal" data-testid="ig-engagement">ER {ig.engagement_rate}%</span>}
      </div>
      <div className="grid grid-cols-3 gap-2 text-center">
        {IG_FIELDS.filter(([k]) => ig[k] != null && ig[k] !== "").map(([k, l]) => (
          <div key={k} className="rounded-lg border border-border p-2">
            <div className="font-heading text-lg font-bold tabular-nums text-foreground">{ig[k]}</div>
            <div className="text-[0.6rem] uppercase tracking-wide text-muted-foreground">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
